<div class="theme-toggle">
  <p-button
    [icon]="themeService.theme() === 'light' ? 'pi pi-moon' : 'pi pi-sun'"
    (click)="toggleTheme()"
    styleClass="p-button-secondary p-button-text"
  />
</div>
<div class="login-container">
  <p-card styleClass="login-card">
    <ng-template pTemplate="header">
      <div class="card-header-title">Backoffice Login</div>
    </ng-template>
    <div class="login-body">
      @if (loginError(); as error) {
        <app-error-banner [message]="error" />
      }
      <p-button
        label="Sign in with Google"
        icon="pi pi-google"
        (click)="signInWithGoogle()"
        styleClass="p-button-teal"
      />
      @if (showPassword()) {
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="field">
            <p-floatLabel>
              <input pInputText id="email" formControlName="email" autocomplete="username" />
              <label for="email">Email</label>
            </p-floatLabel>
          </div>
          <div class="field">
            <p-floatLabel>
              <input
                pInputText
                id="password"
                type="password"
                formControlName="password"
                autocomplete="current-password"
              />
              <label for="password">Password</label>
            </p-floatLabel>
          </div>
          <p-button
            label="Login"
            type="submit"
            [disabled]="loginForm.invalid"
            styleClass="p-button-secondary"
          />
        </form>
      } @else {
        <p-button
          label="Use password instead"
          (click)="showPassword.set(true)"
          styleClass="p-button-text p-button-secondary"
        />
      }
    </div>
  </p-card>
</div>
